import { AttributesMixin, attributes, define, type } from "@type-r/models";
import { handleDateStringWithoutTimeZoneInfo } from "lqx-react/src";
import { AssetData, AssetType } from "./assetData";
import { CommonParticipant } from "./commonParticipant";
import { Component } from "./component";
import { GoverningLaw } from "./governigLaw";

export const CustomIdentifier = attributes({
    name: String,
    value: String
});

export type Buyer = InstanceType<typeof Buyer>;
export const Buyer = attributes({
    ...CommonParticipant.attributes,
    customIdentifiers: type([CustomIdentifier]).value([{ name: 'IdentifierByIP', value: '' }, { name: 'IdentifierByIC', value: '' }])
});

export type Monetization = InstanceType<typeof Monetization>;
export const Monetization = attributes({
    funder: CommonParticipant,
    netFaceValue: type(Number).null,
    tenor: type(Number).null,
    baseRate: type(Number).null,
    baseRatePercentage: type(Number).null,
    baseRateAmount: type(Number).null,
    marginRate: type(Number).null,
    marginRatePercentage: type(Number).null,
    marginRateAmount: type(Number).null,
    totalRate: type(Number).null,
    totalRatePercentage: type(Number).null,
    totalRateAmount: type(Number).null,
    purchasePrice: type(Number).null,
});

export const PurchaseOrder = attributes({
    assetId: Number,
    uid: type(String).value('00000000-0000-0000-0000-000000000000'),
    number: String
});

export interface Invoice extends AttributesMixin<typeof Invoice> { }
@define
export class Invoice extends AssetData {

    static attributes = {
        ...AssetData.attributes,
        assetType: type(AssetType).value({ id: 1, name: 'Invoice' }),

        buyer: Buyer,
        supplier: CommonParticipant,
        relationshipIdentifier: String,
        faceValue: type(Number).value(0),
        currency: String,
        invoiceDate: type(Date).null,
        invoiceDueDate: type(Date).null,
        fundingDate: type(Date).null,
        anticipatedPaymentDate: type(Date).null.parse(dateString => handleDateStringWithoutTimeZoneInfo(dateString)),
        anticipatedSettlementDate: type(Date).null.parse(dateString => handleDateStringWithoutTimeZoneInfo(dateString)),
        promisePayDate: type(Date).null,
        effectiveDate: type(Date).null.parse(dateString => handleDateStringWithoutTimeZoneInfo(dateString)),
        adjustmentAmount: type(Number).value(0),
        outstandingAmountSeller: type(Number).value(0),
        adjustedFaceValue: type(Number).value(0),
        paymentTerms: Number,
        purchaseOrder: PurchaseOrder,
        proposedMonetization: Monetization,
        components: type([Component]),
        governingLaw: GoverningLaw,

        validationCategory: type(Number).dontSave,

        //TODO: not on model
        invoiceStatus: String,
        outstandingAmountFunder: type(Number).value(0),
        isArchived: Boolean,
        alternateId: String,
        notificationNumber: String,
        ref1: String,
        ref2: String,
        ref3: String
    }
    isLoaded: boolean;

    get isDigitized() {
        return this.state.name == 'Digitized';
    }

    public get hasProposedMonetization(): boolean {
        return (this.proposedMonetization != null &&
            ((this.proposedMonetization.funder != null && this.proposedMonetization.funder.name != null && this.proposedMonetization.funder.name != '') ||
                this.proposedMonetization.netFaceValue != null ||
                this.proposedMonetization.tenor != null ||
                this.proposedMonetization.baseRate != null ||
                this.proposedMonetization.baseRatePercentage != null ||
                this.proposedMonetization.baseRateAmount != null ||
                this.proposedMonetization.marginRate != null ||
                this.proposedMonetization.marginRatePercentage != null ||
                this.proposedMonetization.marginRateAmount != null ||
                this.proposedMonetization.totalRate != null ||
                this.proposedMonetization.totalRatePercentage != null ||
                this.proposedMonetization.totalRateAmount != null ||
                this.proposedMonetization.purchasePrice != null));
    }

    onLoaded() {
        if (!this.proposedMonetization) this.proposedMonetization = new Monetization();
        if (!this.proposedMonetization.funder) this.proposedMonetization.funder = new CommonParticipant();
    }
}
